<template>
  <div
    v-if="isBtoC"
    class="page-block">
    <header-bar v-if="isLoggedIn">キャンペーン規約</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">キャンペーン規約</h3>
    </div>
    <div class="page-block__inner">
      <div
        class="terms-area">
        <div class="terms-text__box">
        </div>
        <h4>■ 応募規約</h4>
        <div class="terms-text__box">
          <p>
            株式会社ローディアム（以下、「当社」といいます）が主催する「narasuレビューキャンペーン」
            （以下、「本キャンペーン」といいます）にご応募いただく前に、本規約をよくお読みいただき、ご同意の上、ご応募ください。
            ご応募された場合、本規約にご同意いただいたものとみなします。
          </p>
        </div>
        <h4>■ 応募期間</h4>
        <div class="terms-text__box">
          <p>
            2025年6月16日(月)00:00 〜 6月30日(月)23:59までのフォーム送信
          </p>
        </div>
        <h4>■ 応募方法</h4>
        <div class="terms-text__box">
          <p>
            専用フォームより、必要事項を記載の上ご応募ください。
          </p>
          <p>
            必要事項：
          </p>
          <ol>
            <li>
              ・投稿のURL
            </li>
            <li>
              ・narasuに登録しているメールアドレス
            </li>
            <li>
              ・キャンペーン規約への同意
            </li>
          </ol>
        </div>
        <h4>■謝礼</h4>
        <div class="terms-text__box">
          <p>
            対象条件をすべて満たした応募者に対して、Amazonギフトカード500円分を1アカウント管理者につき1回進呈いたします。
          </p>
        </div>
        <h4>■ 謝礼の対象条件</h4>
        <div class="terms-text__box">
          <p>
            以下条件にすべて該当する場合に、謝礼の対象とします。
          </p>
          <ol>
            <li>
              ・対象SNSに指定のハッシュタグをすべてつけて、応募期間内に投稿すること
              <ol style="padding-left:1.2em;">
                <li>
                  - 対象のSNS：X（旧Twitter）、Instagram（ストーリーズは対象外）、TikTok、YouTube、note
                </li>
                <li>
                  - 指定のハッシュタグ：「#PR」「#narasuレビュー」「#narasu使ってみた」
                </li>
              </ol>
            </li>
            <li>
              ・投稿のURL、narasu登録メールアドレスを応募期間内に専用フォームから送信すること
            </li>
            <li>
              ・投稿は日本語テキストを含むこと
            </li>
            <li>
              ・レビューのテキストは、以下の通り100文字以上の入力を必須とすること
              <ol style="padding-left:1.2em;">
                <li>
                  - X（旧Twitter）／note：投稿本文
                </li>
                <li>
                  - Instagram／TikTok：キャプション本文
                </li>
                <li>
                  - YouTube：動画の概要欄
                </li>
                <li>
                  ※タグは文字数に含めないでください
                </li>
              </ol>
            </li>
            <li>
              ・ハッシュタグの挿入位置は以下の通りとします
              <ol style="padding-left:1.2em;">
                <li>
                  - X：投稿本文
                </li>
                <li>
                  - Instagram／TikTok：キャプション本文
                </li>
                <li>
                  - YouTube：動画の概要欄
                </li>
                <li>
                  - note：本文内またはタグ欄
                </li>
              </ol>
            </li>
            <li>
              ・アカウントや投稿が非公開・限定公開でないこと
            </li>
            <li>
              ・キャンペーン終了後に投稿を削除または編集しないことにご協力いただけること
            </li>
            <li>
              ・同一アカウントから複数回投稿された場合でも、謝礼の進呈は1ユーザーあたり1回のみとします
            </li>
          </ol>
        </div>
        <h4>■ 謝礼の送付について</h4>
        <div class="terms-text__box">
          <p>
            応募期間終了後に内容の確認を行い、投稿条件を満たした方に対して2025年7月末日までに、
            narasuにご登録のメールアドレス宛にAmazonギフトカード（500円分）をお送りします。
          </p>
          <p>
            応募内容に不備がある場合や、対象条件を満たしていないと判断された場合は、謝礼の対象外となります。
          </p>
          <p>
            メールが受信できない・誤記があった等の理由による再送付対応は行いませんので、あらかじめご了承ください。
          </p>
        </div>
        <h4>■ 注意事項</h4>
        <div class="terms-text__box">
          <ol>
            <li>
              ・著作権侵害等、当社が不正と判断した場合、応募・謝礼進呈の対象外となることがあります
            </li>
            <li>
              ・本キャンペーンは、予告なく中止または内容が変更となる場合があります
            </li>
            <li>
              ・当社は必要に応じて本規約を変更し、適正な運営のために必要な対応を行うことができます
            </li>
          </ol>
        </div>
        <h4>■ 禁止事項</h4>
        <div class="terms-text__box">
          <p>
            以下の行為は禁止とし、違反が確認された場合は応募の無効や謝礼の取消し等の対応を行う場合があります。
          </p>
          <p>
            （例）第三者の権利侵害、公序良俗違反、虚偽の情報提供、不正アクセス、営利目的の利用、スパム投稿など
          </p>
        </div>
        <h4>■ 個人情報の取り扱い</h4>
        <div class="terms-text__box">
          <p>
            本キャンペーンにより取得した個人情報は、当社プライバシーポリシー（
            <router-link
              class="c-text-link"
              :to="{name:'privacy'}">
              https://narasu.jp/client/static/privacy
            </router-link>
            ）に基づき、以下の目的で利用します。
          </p>
          <ol>
            <li>
              ・応募者への連絡
            </li>
            <li>
              ・謝礼発送のための確認
            </li>
            <li>
              ・サービス改善のための統計的利用
            </li>
          </ol>
        </div>
        <h4>■ その他</h4>
        <div class="terms-text__box">
          <ol>
            <li>
              ・本キャンペーンへの応募に際し、運営方法や結果等に対して異議申し立てはできません
            </li>
          </ol>
        </div>
        <div class="c-btn-wrap">
          <router-link
            :to="{ name: 'index' }"
            class="c-btn c-btn--back">
            トップへ戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'NarasuCampaign20250601',
  components: { HeaderBar },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
}
</script>

<style lang="scss" scoped>
  ol.numbered{
    margin-left: 1.2em;
    & > li{
    list-style: decimal;
      }
  }
</style>
